import React from 'react';

export const RollerSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 30 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25 0H11.6667C8.83333 0 6.66667 2.12727 6.66667 4.90909H5C2.16667 4.90909 0 7.03636 0 9.81818V14.7273C0 17.5091 2.16667 19.6364 5 19.6364H15C16 19.6364 16.6667 20.2909 16.6667 21.2727V22.9091C14.8333 22.9091 13.3333 24.3818 13.3333 26.1818V32.7273C13.3333 34.5273 14.8333 36 16.6667 36H20C21.8333 36 23.3333 34.5273 23.3333 32.7273V26.1818C23.3333 24.3818 21.8333 22.9091 20 22.9091V21.2727C20 18.4909 17.8333 16.3636 15 16.3636H5C4 16.3636 3.33333 15.7091 3.33333 14.7273V9.81818C3.33333 8.83636 4 8.18182 5 8.18182H6.66667C6.66667 10.9636 8.83333 13.0909 11.6667 13.0909H25C27.8333 13.0909 30 10.9636 30 8.18182V4.90909C30 2.12727 27.8333 0 25 0ZM20 26.1818V32.7273H16.6667V26.1818H20Z" fill={color} />
      </svg>

    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 30 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6835_5789)">
        <path d="M25 0H11.67C8.83 0 6.67 2.13 6.67 4.91H5C2.17 4.91 0 7.04 0 9.82V14.73C0 17.51 2.17 19.64 5 19.64H15C16 19.64 16.67 20.29 16.67 21.28V22.92C14.84 22.92 13.34 24.39 13.34 26.19V32.74C13.34 34.54 14.84 36.01 16.67 36.01H20C21.83 36.01 23.33 34.54 23.33 32.74V26.19C23.33 24.39 21.83 22.92 20 22.92V21.28C20 18.5 17.83 16.37 15 16.37H5C4 16.37 3.33 15.72 3.33 14.73V9.82C3.33 8.84 4 8.18 5 8.18H6.67C6.67 10.96 8.84 13.09 11.67 13.09H25C27.83 13.09 30 10.96 30 8.18V4.91C30 2.13 27.83 0 25 0ZM20 26.18V32.73H16.67V26.18H20Z" fill="#FD2020" />
        <path d="M6.66992 8.18C6.66992 10.96 8.83992 13.09 11.6699 13.09H24.9999C27.8299 13.09 29.9999 10.96 29.9999 8.18V4.91C29.9999 2.13 27.8299 0 24.9999 0H11.6699C8.83992 0 6.66992 2.13 6.66992 4.91M16.6699 22.91C14.8399 22.91 13.3399 24.38 13.3399 26.18V32.73C13.3399 34.53 14.8399 36 16.6699 36H19.9999C21.8299 36 23.3299 34.53 23.3299 32.73V26.18C23.3299 24.38 21.8299 22.91 19.9999 22.91M19.9999 26.18V32.73H16.6699V26.18H19.9999Z" fill="#9EACB0" />
      </g>
      <defs>
        <clipPath id="clip0_6835_5789">
          <rect width="30" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )
}